export default __webpack_public_path__ + "static/media/contrast-bg2.14c35fef.png";